import { ChangeEvent } from "react";

import Form from "react-bootstrap/Form";
import { FormattedMessage, useIntl } from "react-intl";
import { useAuthContext } from "../../../../context/AuthContext";
import { useEcgDetailsContext } from "../../../../context/EcgDetailsContext";
import styles from "./Interpretations.module.css";
import PredefinedInterpretations from "./PredefinedInterpretations/PredefinedInterpretations";
import useTextDirection from "../../../../hooks/useTextDirection";

const Interpretations = () => {
  const {
    state: { loading, ecgEdit, selectedEcg },
    actions: { edit },
  } = useEcgDetailsContext();

  const {
    state: { user },
  } = useAuthContext();

  const intl = useIntl();
  const addInterpretation = intl.messages[
    "ECG_DETAILS.INSERT_INTERPRETATIONS"
  ] as string;

  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    if (!ecgEdit) return;
    ecgEdit.interpretation = event.currentTarget.value;

    edit(ecgEdit);
  };

  const addPredefinedInterpretation = (predefinedInterpretation: string) => {
    if (!ecgEdit) return;

    ecgEdit.interpretation = ecgEdit.interpretation
      ? `${ecgEdit.interpretation} + ${predefinedInterpretation}`
      : predefinedInterpretation;

    edit(ecgEdit);
  };

  const defaultValue =
    selectedEcg?.interpretation?.user.id === user?.id
      ? selectedEcg?.interpretation?.text
      : undefined;

  const isRequired = selectedEcg?.permissions?.interpretationRequired;

  const predefinedInterpretations: string[] = [
    "See findings",
    "No acute changes",
    "No acute findings",
    "No change from prior ECGs",
  ];

  const textDirection = useTextDirection(
    ecgEdit?.interpretation ?? defaultValue ?? ""
  );

  return (
    <div className="p-2 overflow-auto d-flex flex-column h-100">
      {isRequired && (
        <p className="mb-1 font-sm">
          <span className="prim-color">*</span>&nbsp;
          <FormattedMessage
            id="ECG_DETAILS.INSERT_INTERPRETATIONS_REQUIRED"
            defaultMessage="Insert interpretation"
          />
        </p>
      )}

      {!!predefinedInterpretations?.length && (
        <div className="mb-2">
          <PredefinedInterpretations
            items={predefinedInterpretations}
            onItemClick={addPredefinedInterpretation}
          />
        </div>
      )}

      <Form.Control
        as="textarea"
        placeholder={addInterpretation}
        className={`${styles.input} flex-grow-1`}
        value={ecgEdit?.interpretation ?? defaultValue ?? ""}
        onChange={changeHandler}
        disabled={loading || ecgEdit?.isReadable === false}
        dir={textDirection}
      />
    </div>
  );
};

export default Interpretations;
